exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icons-grid[data-v-8a30ef3c] {\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  place-items: end;\n}\n.iheart[data-v-8a30ef3c] {\n  width: 40px;\n  height: 40px;\n  border-radius: 5px;\n}\n", ""]);

// exports
